/** Activities 등에서 'New' 뱃지를 표시할 기간(일) */
export const NEW_BADGE_WINDOW_DAYS = 28;

/**
 * 표시용 date 문자열 "YYYY.MM.DD." → ISO 날짜 "YYYY-MM-DD"
 */
export function parseActivityDisplayDateToIso(dateStr: string): string | null {
  const m = dateStr.trim().match(/^(\d{4})\.(\d{2})\.(\d{2})\.?$/);
  if (!m) return null;
  return `${m[1]}-${m[2]}-${m[3]}`;
}

/**
 * 페이지 공개일(로컬 자정 기준)부터 NEW_BADGE_WINDOW_DAYS 이내이면 true
 * @param launchDateIso - "YYYY-MM-DD" (또는 ISO 전체 문자열)
 */
export function isWithinNewBadgeWindow(launchDateIso: string): boolean {
  const normalized = launchDateIso.length > 10 ? launchDateIso.slice(0, 10) : launchDateIso;
  const launch = new Date(`${normalized}T00:00:00`);
  if (Number.isNaN(launch.getTime())) return false;
  const now = new Date();
  const diffMs = now.getTime() - launch.getTime();
  if (diffMs < 0) return false;
  const days = diffMs / (1000 * 60 * 60 * 24);
  return days <= NEW_BADGE_WINDOW_DAYS;
}
